import { defaultTeamStrategySettings } from "../../../../components";
import { ITeamStrategySettings, useSettings } from "../../../../hooks";

const useTeamStrategySettings = (teamSlug: string) => {
  const {
    teamStrategySettings: { [teamSlug]: unsafeSettings },
    updateTeamStrategySettings,
  } = useSettings();

  const safeSettings: ITeamStrategySettings = {
    ...defaultTeamStrategySettings,
    ...unsafeSettings,
  };

  return {
    settings: safeSettings,
    updateSettings: (updatedSettings: Partial<ITeamStrategySettings>) => {
      updateTeamStrategySettings(teamSlug, updatedSettings);
    },
  };
};

export { useTeamStrategySettings };
